import React from 'react'

import type { Image } from 'types'
import style from './style.module.css'

type Props = Image

function ImageGalleryImage({ sizes, alt }: Props) {
  return (
    <div className={style.wrapper}>
      <img alt={alt} src={sizes?.large} />
    </div>
  )
}

export default ImageGalleryImage
